const Tag = {
  IsDefault: 1,
  IsNotDefault: 0
};
export default Tag;
